import { render, staticRenderFns } from "./LitterRegistrationSignature.vue?vue&type=template&id=0ec6fdf0"
import script from "./LitterRegistrationSignature.vue?vue&type=script&lang=ts"
export * from "./LitterRegistrationSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports